module.exports = __webpack_public_path__ + "86c0860014789b7595416c8baefaf382.pdf";